import ReactDOMServer from 'react-dom/server';
import $ from 'jquery';
import appAjax from '../helpers/ajax';
import appUi from '../helpers/ui';
import { useEffect, useState } from 'react';
import Loader from '../components/Loader';

import FormLogActivity from '../components/FormLogActivity';

export default function ModalFormActivity(props)
{
  var isInitialLoad = false;

  const [elModal, setElModal] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [listMasterActivity, setListMasterActivity] = useState([]);

  const doLoadData = () => {
    appAjax._ajax_send(null, {
      type: 'GET',
      beforeSend: () => {
       setIsLoading(true);
       setErrorMessage(null);
      },
      success: (response) => {
        setListMasterActivity(response.data);
      },
      error: (response) => {
        setErrorMessage(response.message || 'Failed to load files');
      },
      always: () => {
        setIsLoading(false);
      }
    }, 'Get master data...', appAjax.apiBaseUrl + '/activity/masters');
  };

  const onClickMasterActivity = (e) => {
    var elRow = $(e.currentTarget).closest('.row_masteractivity');
    var masterId = elRow.data('activity-id');
    var currentLocation = appAjax.currentGeoLocation;;

    //-- Render form log activity
    var container = elRow.find('.activityform_container');
    var formLogActivityHtml = ReactDOMServer.renderToString(
      <FormLogActivity />
    );
    container.html(formLogActivityHtml);
    container.find('.form_logactivity input[name="activity_uuid"]').val(masterId);
    if (currentLocation !== null) {
      container.find('.form_logactivity input[name="lat"]').val(currentLocation.lat);
      container.find('.form_logactivity input[name="lng"]').val(currentLocation.lng);
    }
    container.find('form.form_logactivity').on('submit', onSubmitFormLogActivity);
    container.find('textarea[name="notes"]').focus();
  };

  const onSubmitFormLogActivity = (e) => {
    e.preventDefault();
    var elForm = e.target;
    var formData = $(elForm).serialize();

    appAjax._ajax_send(formData, {
      type: 'POST',
      beforeSend: function() {
        $(elForm).find('button, input[type=text], textarea').attr('disabled', 'disabled');
      },
      success: function(response) {
        appUi.uiToast(response.message, 'success');
        $(elModal).modal('hide');
      },
      error: function(response) {
        appUi.uiAlert(response.message, null, 'Failed', 'error');
      },
      always: function() {
        $(elForm).find('button, input[type=text], textarea').removeAttr('disabled');
      }
    }, 'Saving...', appAjax.apiBaseUrl + '/activity/logs');
    return false;
  };

  useEffect(() => {
    if (isInitialLoad) return;
    isInitialLoad = true;
    
    var tmp = $('#web_modal_formactivity');
    setElModal(tmp);

    $(tmp).on('shown.bs.modal', () => {
      doLoadData();
    });
  }, []);

  return (
    <div
      className="modal"
      style={{ display: "none" }}
      tabIndex={-1}
      id="web_modal_formactivity"
    >
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><i className="fa fa-list me-1"></i> Activity Form</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>    
          <div className="modal-body">
            {isLoading ? (
              <div className="text-center">
                <Loader />
              </div>
            ) : (
              <div>
              {errorMessage ? (
                <div className="alert alert-danger" role="alert">
                  {errorMessage}
                </div>
              ) : (
                <div>
                  {listMasterActivity.map((item, index) => (
                    <div key={index} className="mb-2 row_masteractivity" data-activity-id={item.uuid}>
                      <button type="button" className="btn btn-light w-100" onClick={onClickMasterActivity}>
                        <i className={'me-1 ' + item.activity_icon_class}></i> {item.activity_label}
                      </button>

                      <div className="activityform_container"></div>
                    </div>
                  ))}
                </div>
              )}
              </div>
            )}

          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

  );
};
